import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import { sortableElement, sortableHandle } from 'react-sortable-hoc';
import SelectionBox from './SelectionBox';
import { FrozenDirection } from './Column';

import frozenLeftIcon from '@adsk/bim360-matrix-react-assets/frozen-left.svg';
import frozenRightIcon from '@adsk/bim360-matrix-react-assets/frozen-right.svg';
import dragIcon from '@adsk/bim360-matrix-react-assets/drag-icon.svg';

import './_ColumnsToggleItem.scss';

const DragIcon = sortableHandle(() => (
  <SvgIcon className="ColumnsToggleItem__drag-icon">{dragIcon}</SvgIcon>
));

class ColumnsToggleItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this._handleToggle = this._handleToggle.bind(this);
    this._handleFrozenLeft = this._handleFrozenLeft.bind(this);
    this._handleFrozenRight = this._handleFrozenRight.bind(this);
  }

  renderItem() {
    const { column, freezable, draggable } = this.props;
    const { key, title, disabled, toggleable = true, frozen, hidden } = column;

    const cls = cn('ColumnsToggleItem', {
      'ColumnsToggleItem--disabled': disabled || !toggleable,
      'ColumnsToggleItem--frozen': frozen
    });

    const leftIconCls = cn('ColumnsToggleItem__icon', {
      'ColumnsToggleItem__icon--active': frozen === FrozenDirection.LEFT
    });
    const rightIconCls = cn('ColumnsToggleItem__icon', {
      'ColumnsToggleItem__icon--active': frozen === FrozenDirection.RIGHT
    });
    const showIcon = !disabled && !hidden && freezable;
    return (
      <div key={key} className={cls} onClick={this._handleToggle}>
        {draggable && !disabled && <DragIcon />}
        <SelectionBox checked={!hidden} disabled={disabled || !toggleable} />
        <span className="ColumnsToggleItem__label">{title}</span>
        {showIcon && (
          <IconButton
            styleType={IconButton.StyleType.MINIMAL}
            className={leftIconCls}
            onClick={this._handleFrozenLeft}
          >
            <SvgIcon>{frozenLeftIcon}</SvgIcon>
          </IconButton>
        )}
        {showIcon && (
          <IconButton
            styleType={IconButton.StyleType.MINIMAL}
            className={rightIconCls}
            onClick={this._handleFrozenRight}
          >
            <SvgIcon>{frozenRightIcon}</SvgIcon>
          </IconButton>
        )}
      </div>
    );
  }

  render() {
    const { draggable, column } = this.props;
    const DragableItem = sortableElement(() => this.renderItem());

    return draggable ? <DragableItem index={column.position} /> : this.renderItem();
  }

  _handleToggle() {
    const { column, onToggle } = this.props;

    if (column.disabled || column.toggleable === false) return;
    onToggle(column, !column.hidden);
  }

  _handleFrozenLeft(event) {
    event.stopPropagation();
    this._handleFrozen(FrozenDirection.LEFT);
  }

  _handleFrozenRight(event) {
    event.stopPropagation();
    this._handleFrozen(FrozenDirection.RIGHT);
  }

  _handleFrozen(frozen) {
    const { column, onFrozen } = this.props;
    if (column.disabled) return;
    onFrozen(column, column.frozen === frozen ? false : frozen);
  }
}

ColumnsToggleItem.propTypes = {
  column: PropTypes.object,
  freezable: PropTypes.bool,
  draggable: PropTypes.bool,
  onToggle: PropTypes.func,
  onFrozen: PropTypes.func
};

export default ColumnsToggleItem;
